import { createFileRoute } from '@tanstack/react-router';

import Page from '@/screens/chat/skills/edit/chatId/page';

export const Route = createFileRoute('/_app/_chat/skills/edit/$chatId/')({
  component: Page,
});
